import styled from 'styled-components';
import theme from 'theme/theme';

const Title4 = styled.h4`
  display: flex;
  padding: 0;
  margin: 0;
  font-size: ${theme.fontSizes.medium};
`;

export default Title4;
